/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateCreditAllocationPayload = {
    validUntil?: string | null;
    categoryId: number;
    totalCredits: number;
    source: CreateCreditAllocationPayload.source;
    note?: string | null;
};
export namespace CreateCreditAllocationPayload {
    export enum source {
        PACKAGE = 'package',
        AGREEMENT = 'agreement',
        PRO_BONO = 'pro_bono',
        OTHER = 'other',
    }
}

